<lb-lesson-card
	[lesson]="lesson()"
	[lessonView]="lessonView()"
	[displayedUser]="displayedUser()"
	[isPopup]="isPopup()"
	[detailsLink]="detailsLink()"
	(dataChanged)="dataChanged.emit()"
>
	<ng-content lesson-dropdown-area>
		<div class="readonly-layout">
			<md-tag type="tertiary" class="chip--icon">
				<md-icon [icon]="lessonTypeIcon()"></md-icon>
				{{ lesson().lessonTypeName }}
			</md-tag>
			@if (lesson().attendanceStatusName) {
				<md-tag [type]="attendanceTagType()" class="chip--icon">
					<md-icon [icon]="attendanceIcon()"></md-icon>
					{{ lesson().attendanceStatusName }}
				</md-tag>
			}
		</div>
	</ng-content>
</lb-lesson-card>
